// extracted by mini-css-extract-plugin
module.exports = {"content":"_Footer_content__3CJ1z","footer":"_Footer_footer__Or9UT","logo":"_Footer_logo__1g4n-","wrapper":"_Footer_wrapper__3NsJc","copyright":"_Footer_copyright__3laHY"};